var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 46,
    viewBox: "0 0 29 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53428 10.6829C8.53428 7.71421 9.69215 4.86047 11.7656 2.71872L14.3977 0L17.0955 2.6926C19.2542 4.8472 20.4657 7.76088 20.4657 10.7978V11.1724H29V33.4053C29 34.7477 28.3894 36.0185 27.338 36.8642L14.8721 45.8692C14.6552 46.0436 14.3448 46.0436 14.1279 45.8692L1.66204 36.8642C0.610625 36.0185 0 34.7477 0 33.4053V11.1724H8.53428V10.6829ZM14.4472 5.52C12.5063 7.52418 11.4228 10.1929 11.4228 12.9688V16.7193V30.9781C9.94563 30.9781 8.74816 29.7921 8.74816 28.3289V18.925C8.74816 16.1743 6.49488 13.9444 3.7153 13.9444V30.9781V30.9796V31.0208H3.71549C3.73865 33.7519 5.98298 35.9588 8.74816 35.9588H11.4228V35.9607C11.4228 38.1401 12.6224 40.1465 14.5527 41.1956C16.4223 40.1441 17.5772 38.1799 17.5772 36.0518V35.9588H20.2518C23.017 35.9588 25.2613 33.7519 25.2845 31.0208H25.2847V30.9781V13.9444C22.5051 13.9444 20.2518 16.1743 20.2518 18.925V28.3289C20.2518 29.7921 19.0544 30.9781 17.5772 30.9781V16.7193V13.0417C17.5772 10.2241 16.4522 7.52055 14.4472 5.52Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b7e8b01500d487ef7182a85f4651af08.svg";
export { ForwardRef as ReactComponent };